import React, { ReactNode, useMemo, ComponentPropsWithoutRef } from "react";
import { LayoutUtilProps } from "../../types";
import { useLayoutPropsUtil } from "../../internal/hooks";
import { LocalizationContext } from "./LocalizationContext";
import { useTranslations } from "./useTranslations";

type LocalizationProviderProps = ComponentPropsWithoutRef<"div"> &
  LayoutUtilProps & {
    children: ReactNode;
    translationData: ITranslations;
  };

export type TranslationResult = string | Translations | undefined;

export interface Translations {
  [key: string]: TranslationResult;
}

export interface ITranslations {
  dir: "ltr" | "rtl";
  locale?: string;
  translations: Translations;
}

export const LocalizationProvider: React.FC<LocalizationProviderProps> = (
  props,
) => {
  const { layoutStyles, componentProps } = useLayoutPropsUtil(props);

  const { children, translationData, style, ...rest } = componentProps;
  const { locale = "en", dir, translations } = translationData;

  const styleCombined = { ...style, ...layoutStyles };

  const { translations: t } = useTranslations(translations);

  const value = useMemo(() => ({ t, locale }), [locale, t]);

  return (
    <LocalizationContext.Provider value={value}>
      <div style={styleCombined} {...rest} dir={dir}>
        {children}
      </div>
    </LocalizationContext.Provider>
  );
};
